/**
 * OSAPIENS third-party export provider.
 *
 * Wraps the OSAPIENS build/validate logic (src/utils/osapiensExport.js) in the generic
 * provider descriptor shape consumed by ThirdPartyExportDialog + FinalReport. To add another
 * third-party system, create a sibling descriptor and register it in ./index.js — no dialog or
 * component changes required.
 */
import {
  validateForOsapiens,
  buildOsapiensGeoJson,
  OSAPIENS_RULE_VERSION,
  OSAPIENS_COMMODITIES,
} from '@/utils/osapiensExport.js';
import { isGeoJSONObject } from 'geojson-validation';

export default {
  key: 'osapiens',
  label: 'OSAPIENS',

  // i18n namespace for this provider's own copy (intro, disclaimers, cat.*, field.*).
  i18nPrefix: 'dueDiligence.osapiens',
  disclaimerKeys: [
    'disclaimerStandardUnchanged',
    'disclaimerFileOnly',
    'disclaimerNoInvent',
    'disclaimerThirdParty',
    'disclaimerNotReplacement',
  ],

  fileExtension: '.geojson',
  ruleVersion: OSAPIENS_RULE_VERSION,
  fileBaseName: ({ diligenceId }) => `osapiens-compatible-${diligenceId || 'dds'}-${Date.now()}`,

  /**
   * How each resolvable missing field is entered in the review step, and which key the entered
   * value is written to in the per-plot resolutions object the builder expects.
   */
  fieldInput: {
    eudr_commodity: { type: 'select', items: OSAPIENS_COMMODITIES, resolutionKey: 'commodity' },
    country_code: { type: 'text', maxlength: 2, resolutionKey: 'countryCode' },
    scientific_products: { type: 'text', resolutionKey: 'scientificProducts' },
  },

  validate: (places, report) => validateForOsapiens(places, report),
  build: (places, report, opts) => buildOsapiensGeoJson(places, report, opts),
  serialize: (obj) => JSON.stringify(obj),
  validateOutput: (obj) => isGeoJSONObject(obj),
};
